import { render, staticRenderFns } from "./SearchChips.vue?vue&type=template&id=4bb3693d&scoped=true"
import script from "./SearchChips.vue?vue&type=script&lang=js"
export * from "./SearchChips.vue?vue&type=script&lang=js"
import style0 from "./SearchChips.vue?vue&type=style&index=0&id=4bb3693d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3693d",
  null
  
)

export default component.exports